/**
 * @generated SignedSource<<6b7bf1be716696382c5efe4650927424>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CustomFieldType = "FREE_TEXT" | "DROPDOWN" | "%future added value";
export type UpdateTicketingCustomFieldDefinitionInput = {
  id: string;
  name?: string | null;
  options?: ReadonlyArray<string> | null;
  readOnly?: boolean | null;
  requiredOnResolution?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type useUpdateCustomFieldDefinitionMutation$variables = {
  input: UpdateTicketingCustomFieldDefinitionInput;
};
export type useUpdateCustomFieldDefinitionMutation$data = {
  readonly updateTicketingCustomFieldDefinition: {
    readonly clientMutationId: string | null;
    readonly customFieldDefinition: {
      readonly id: string;
      readonly name: string;
      readonly key: string;
      readonly fieldType: CustomFieldType;
      readonly options: ReadonlyArray<string> | null;
      readonly readOnly: boolean;
      readonly requiredOnResolution: boolean;
    } | null;
  } | null;
};
export type useUpdateCustomFieldDefinitionMutation = {
  variables: useUpdateCustomFieldDefinitionMutation$variables;
  response: useUpdateCustomFieldDefinitionMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateTicketingCustomFieldDefinitionPayload",
    "kind": "LinkedField",
    "name": "updateTicketingCustomFieldDefinition",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "TicketingCustomFieldDefinition",
        "kind": "LinkedField",
        "name": "customFieldDefinition",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "key",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fieldType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "options",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "readOnly",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "requiredOnResolution",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUpdateCustomFieldDefinitionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUpdateCustomFieldDefinitionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cbd1ae4be62898c32127e3d5acf7ef4c",
    "id": null,
    "metadata": {},
    "name": "useUpdateCustomFieldDefinitionMutation",
    "operationKind": "mutation",
    "text": "mutation useUpdateCustomFieldDefinitionMutation(\n  $input: UpdateTicketingCustomFieldDefinitionInput!\n) {\n  updateTicketingCustomFieldDefinition(input: $input) {\n    clientMutationId\n    customFieldDefinition {\n      id\n      name\n      key\n      fieldType\n      options\n      readOnly\n      requiredOnResolution\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7069e14988d38484d3f395cc8751d377";

export default node;
